export const notificationsMobileItems = [
  {
    content:
      "Hi there! I am wondering if you can help me with a problem I've been having.",
    duration: "2 min ago",
  },
  {
    content:
      "Hi there! I am wondering if you can help me with a problem I've been having.",
    duration: "2 min ago",
    unread: "false",
  },
  {
    content:
      "Hi there! I am wondering if you can help me with a problem I've been having.",
    duration: "2 min ago",
    unread: "true",
  },
  {
    content:
      "Hi there! I am wondering if you can help me with a problem I've been having.",
    duration: "2 min ago",
    unread: "false",
  },
  {
    content:
      "Hi there! I am wondering if you can help me with a problem I've been having.",
    duration: "2 min ago",
    unread: "true",
  },
];

export const messagesMobileItems = [
  // {
  //   name: "Emily Fowler",
  //   content:
  //     "Hi there! I am wondering if you can help me with a problem I've been having.",
  //   duration: "2 min ago",
  //   image: "https://fakeimg.pl/440x320/",
  //   unread: "true",
  // },
  {
    name: "Momo sisi",
    content: "Dir chi taman mzn.",
    duration: "2 min ago",
    image: "https://source.unsplash.com/Mv9hjnEUHR4/60x60",
    unread: "true",
  },
  {
    name: "Momo sisi",
    content: "Dir chi taman mzn.",
    duration: "2 min ago",
    image: "https://source.unsplash.com/Mv9hjnEUHR4/60x60",
    unread: "true",
  },
  {
    name: "Emily Fowler",
    content:
      "Hi there! I am wondering if you can help me with a problem I've been having.",
    duration: "2 min ago",
    image: "https://i.imgur.com/zYxDCQT.jpg",
    unread: "false",
  },
  {
    name: "Momo sisi",
    content: "Dir chi taman mzn.",
    duration: "2 min ago",
    image: "https://source.unsplash.com/Mv9hjnEUHR4/60x60",
    unread: "false",
  },
  {
    name: "Emily Fowler",
    content: "Hi there! I am wondering if you .",
    duration: "2 min ago",
    image: "https://i.imgur.com/ltXdE4K.jpg",
    unread: "false",
  },
  {
    name: "Momo sisi",
    content: "Dir chi taman mzn.",
    duration: "2 min ago",
    image: "https://source.unsplash.com/Mv9hjnEUHR4/60x60",
    unread: "false",
  },
  {
    name: "Emily Fowler",
    content: "Hi there! I am wondering if you .",
    duration: "2 min ago",
    image: "https://i.imgur.com/ltXdE4K.jpg",
    unread: "false",
  },
  {
    name: "Emily Fowler",
    content: "Hi there! I am wondering if you .",
    duration: "2 min ago",
    image: "https://i.imgur.com/ltXdE4K.jpg",
    unread: "false",
  },
];
